import request from '@/utils/request'

// 查询商品配饰列表
export function listAccessory(data) {
  return request({
    url: '/sysOrderGrabbing/list',
    method: 'post',
    data,
  })
}

// 查询商品配饰详细
export function getAccessory(id) {
  return request({
    url: '/system/accessory/' + id,
    method: 'get',
  })
}

// 新增商品配饰
export function addAccessory(data) {
  return request({
    url: '/system/accessory',
    method: 'post',
    data: data,
  })
}

// 修改商品配饰
export function updateAccessory(data) {
  return request({
    url: '/system/accessory',
    method: 'put',
    data: data,
  })
}

// 删除商品配饰
export function delAccessory(id) {
  return request({
    url: '/system/accessory/' + id,
    method: 'delete',
  })
}

// 取消 抢单
export function cancelGrabbing(data) {
  return request({
    url: '/sysOrderGrabbing/cancel',
    method: 'post',
    data,
  })
}

// 确认 抢单
export function confirmGrabbing(data) {
  return request({
    url: '/sysOrderGrabbing/confirm',
    method: 'post',
    data,
  })
}

// 抢单人历史评价
export function commentGrabbing(data) {
  return request({
    url: '/sysOrderGrabbingComment/list',
    method: 'post',
    data,
  })
}

// 评价
export function insertComment(data) {
  return request({
    url: '/sysOrderGrabbingComment/insert',
    method: 'post',
    data,
  })
}
